import { getRequestContext } from '../context';
import { checkIsLiteStore } from '../storeInfo';
import { getB2BDomainByEnv, getB2BUrlByEnv } from './getB2BUrlByEnv';
import { getKitLiteDomainByEnv, getKitLiteUrlByEnv } from './getKitLiteUrlByEnv';
import { OAUTH_CODE_STATE_FIELDS } from './oauth';

/** URL для подключения источника OZON через OAuth */
export const OZON_OAUTH_API_URL = 'https://seller.ozon.ru/app/appstore/oauth/authorize';

/** Путь для обработки OAuth-колбека Ozon */
export const OZON_OAUTH_CALLBACK_PATH = '/ozon-oauth-callback';

/* Redirect URI для OAuth OZON */
export const getOzonRedirectStaticUri = () => {
    const getUrlByEnv = checkIsLiteStore() ? getKitLiteUrlByEnv : getB2BUrlByEnv;

    return getUrlByEnv(OZON_OAUTH_CALLBACK_PATH);
};

/**
 * Cookie domain для передачи результата OAuth из popup в кабинет магазина.
 *
 * @kind helper
 */
export const getOzonOauthCookieDomain = () => {
    const { isYCPDomain } = getRequestContext();

    return isYCPDomain || checkIsLiteStore() ? getKitLiteDomainByEnv() : getB2BDomainByEnv();
};

/* Ключ для идентификации OAuth-параметров Ozon */
export const OZON_OAUTH_STORAGE_KEY = 'ozon-oauth-params';

export const OZON_OAUTH_COOKIE_FIELDS = OAUTH_CODE_STATE_FIELDS;
